<div class="logs-signpost-custom-waf-rule-groups">
    <ng-content></ng-content>

    <avi-dynamic-data-grid
        *ngIf="trafficLogsSignpostStore.logsWafGroupsSignpostData$ | async as logsWafGroupsSignpostData"
        class="logs-signpost-custom-waf-rule-groups__data-grid"
        [config]="wafGroupsGridConfig"
        [rows]="logsWafGroupsSignpostData"
        [rowsTotal]="logsWafGroupsSignpostData.length"
    ></avi-dynamic-data-grid>
</div>
<div
    class="logs-signpost-custom-waf-rule-groups__loader clr-wrapper"
    *ngIf="trafficLogsSignpostStore.isLoading$ | async"
>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</div>

<ng-template
    #expandedContentNameFieldTemplateRef
    let-rule
>
    <div class="logs-signpost-custom-waf-rule-groups__expanded-content-rule-name-wrapper">
        <span
            class="logs-signpost-custom-waf-rule-groups__expanded-content-rule-id"
            *ngIf="rule.ruleId.value"
            logFilter
            [property]="rule.ruleId.param"
            [operator]="FilterOperatorType.EQUAL_TO"
            [value]="rule.ruleId?.value"
            (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
        >
            {{ rule.ruleId.value }}
        </span>
        <ng-container
            *ngIf="!rule.ruleId.value"
            [ngTemplateOutlet]="noData"
            [ngTemplateOutletContext]="{ $implicit: rule.ruleId?.param }"
        ></ng-container>
        <span
            class="logs-signpost-custom-waf-rule-groups__expanded-content-rule-name"
            *ngIf="rule.ruleName.value"
            logFilter
            [property]="rule.ruleName.param"
            [operator]="FilterOperatorType.EQUAL_TO"
            [value]="rule.ruleName?.value"
            (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
            aviTitle="{{ rule.ruleName.value }}"
        >
            {{ rule.ruleName.value }}
        </span>
        <ng-container
            *ngIf="!rule.ruleName.value"
            [ngTemplateOutlet]="noData"
            [ngTemplateOutletContext]="{ $implicit: rule.ruleName?.param }"
        ></ng-container>
    </div>
</ng-template>

<ng-template
    #nameFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        class="logs-signpost-custom-waf-rule-groups__group-name"
        logFilter
        *ngIf="row.value.value"
        [property]="row.value.param"
        [operator]="FilterOperatorType.EQUAL_TO"
        [value]="row.value.value"
        (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
    >
        {{ row.name }}
    </span>
    <ng-container
        *ngIf="!row.value.value"
        [ngTemplateOutlet]="noData"
        [ngTemplateOutletContext]="{ $implicit: row.value?.param }"
    ></ng-container>
</ng-template>

<ng-template
    #noData
    let-property
>
    <span
        logFilterableEmptyField
        [property]="property"
        (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
        class="logs-signpost-custom-waf-rule-groups__empty-field"
    ></span>
</ng-template>
